import { Injectable } from '@angular/core';
import { AIASSIST_FUNCTIONS_NAMESPACE } from '../../interfaces/imetadata';
import { UidGenerator } from '../../utils/uidGenerator';
import { IFunction } from './ifunction';
import { IFunctionProvider } from './ifunctionprovider';

type AiAssistPromptConfig = {
  name: string;
  args: {
    corpId: string;
    promptProfileId: string;
  };
  out: string;
};

@Injectable({ providedIn: 'root' })
export class AiAssistFunctionProviderService implements IFunctionProvider {
  constructor() {}

  async build(functionConfig: any): Promise<IFunction> {
    if (functionConfig.name === 'aiAssistPrompt') {
      const { namespace, ...config } = functionConfig;
      this.assertNamespace(namespace);
      return this.buildAiAssistPromptFunction(namespace, config);
    }

    throw new Error(`Unknown function ${functionConfig.name}.`);
  }

  private async buildAiAssistPromptFunction(namespace: string, functionConfig: AiAssistPromptConfig): Promise<IFunction> {
    return {
      id: UidGenerator.generateUUID(),
      namespace: namespace,
      type: 'function',
      config: { ...functionConfig },
      fullyQualifiedName: `${AIASSIST_FUNCTIONS_NAMESPACE}.${functionConfig.name}`,
    };
  }

  private assertNamespace(namespace: string): void {
    if (!namespace || namespace.length === 0) {
      throw new Error('Namespace should be defined for AiAssist functions.');
    }
  }
}
